
// Libs
import PubSub from 'underpub-js';
import Sitewide from './classes/Sitewide';
import ComponentsLoader from './classes/ComponentsLoader';

// Components Import -- DO NOT REMOVE COMMENT!
import WhatsAppWidget from "../components/molecules/Global/WhatsAppWidget/WhatsAppWidget";
import CodeEmbed from "../components/molecules/Misc/CodeEmbed/CodeEmbed";
import ModalCodeEmbed from "../components/molecules/Modals/ModalCodeEmbed/ModalCodeEmbed";
import CalloutWithEmbedModal from "../components/molecules/Misc/CalloutWithEmbedModal/CalloutWithEmbedModal";
import HighlightCallToAction from "../components/molecules/Highlights/HighlightCallToAction/HighlightCallToAction";
import HighlightCalloutShapedImage from "../components/molecules/Highlights/HighlightCalloutShapedImage/HighlightCalloutShapedImage";
import CalloutDualImage from "../components/molecules/Misc/CalloutDualImage/CalloutDualImage";
import HeroBackgroundImage from "../components/molecules/Heros/HeroBackgroundImage/HeroBackgroundImage";
import CalculatorExtended from "../components/molecules/Misc/CalculatorExtended/CalculatorExtended";
import Calculator from "../components/molecules/Misc/Calculator/Calculator";
import ModalAlert from "../components/molecules/Global/ModalAlert/ModalAlert";
import ListingJobsDirectorySection from "../components/elements/Listings/ListingJobsDirectorySection/ListingJobsDirectorySection";
import ListingJobsDirectory from "../components/molecules/Listings/ListingJobsDirectory/ListingJobsDirectory";
import HighlightForm from "../components/molecules/Highlights/HighlightForm/HighlightForm";
import Banner from "../components/molecules/Global/Banner/Banner";
import Intro from "../components/molecules/Misc/Intro/Intro";
import ListingUnitsDirectoryFilters from "../components/elements/Listings/ListingUnitsDirectoryFilters/ListingUnitsDirectoryFilters";
import ListingUnitsDirectorySection from "../components/elements/Listings/ListingUnitsDirectorySection/ListingUnitsDirectorySection";
import ListingUnitsDirectory from "../components/molecules/Listings/ListingUnitsDirectory/ListingUnitsDirectory";
import NavigationBarSubItem from "../components/atoms/Global/NavigationBarSubItem/NavigationBarSubItem";
import NavigationBarItem from "../components/atoms/Global/NavigationBarItem/NavigationBarItem";
import NavigationBar from "../components/molecules/Global/NavigationBar/NavigationBar";
import EmbedSpotlight from "../components/molecules/Misc/EmbedSpotlight/EmbedSpotlight";
import UnitInformation from "../components/molecules/Unit/UnitInformation/UnitInformation";
import ButtonTertiary from "../components/atoms/Buttons/ButtonTertiary/ButtonTertiary";
import PopupUnit from "../components/elements/Popup/PopupUnit/PopupUnit";
import FloorPlansMap from "../components/molecules/Misc/FloorPlansMap/FloorPlansMap";
import ListingResidenceCategories from "../components/molecules/Listings/ListingResidenceCategories/ListingResidenceCategories";
import ListingUnits from "../components/molecules/Listings/ListingUnits/ListingUnits";
import Carousel from "../components/elements/Misc/Carousel/Carousel";
import ModalUnit from "../components/molecules/Modals/ModalUnit/ModalUnit";
import CardUnit from "../components/elements/Cards/CardUnit/CardUnit";
import HighlightMap from "../components/molecules/Highlights/HighlightMap/HighlightMap";
import Map from "../components/elements/Maps/Map/Map";
import ListingReferences from "../components/molecules/Listings/ListingReferences/ListingReferences";
import BlogNavigation from "../components/molecules/Blog/BlogNavigation/BlogNavigation";
import PostSpotlight from "../components/molecules/Post/PostSpotlight/PostSpotlight";
import CardFour from "../components/elements/Cards/CardFour/CardFour";
import ListingPressReleases from "../components/molecules/Listings/ListingPressReleases/ListingPressReleases";
import ContainerPressReleases from "../components/layouts/Containers/ContainerPressReleases/ContainerPressReleases";
import ListingPosts from "../components/molecules/Listings/ListingPosts/ListingPosts";
import MediaCarousel from "../components/molecules/Media/MediaCarousel/MediaCarousel";
import RecipeSection from "../components/elements/Misc/RecipeSection/RecipeSection";
import Recipe from "../components/molecules/Misc/Recipe/Recipe";
import MediaDuo from "../components/molecules/Media/MediaDuo/MediaDuo";
import MediaSingle from "../components/molecules/Media/MediaSingle/MediaSingle";
import ShareSnippet from "../components/elements/Misc/ShareSnippet/ShareSnippet";
import PostInformation from "../components/molecules/Post/PostInformation/PostInformation";
import HeroPost from "../components/molecules/Heros/HeroPost/HeroPost";
import RichText from "../components/molecules/Misc/RichText/RichText";
import Loader from "../components/molecules/Global/Loader/Loader";
import Timeline from "../components/molecules/Misc/Timeline/Timeline";
import ListingFeatures from "../components/molecules/Listings/ListingFeatures/ListingFeatures";
import ListingCommunitiesSection from "../components/elements/Listings/ListingCommunitiesSection/ListingCommunitiesSection";
import ListingCommunities from "../components/molecules/Listings/ListingCommunities/ListingCommunities";
import ListingRegions from "../components/molecules/Listings/ListingRegions/ListingRegions";
import ContactBlock from "../components/molecules/Misc/ContactBlock/ContactBlock";
import TeamMemberInformation from "../components/molecules/TeamMember/TeamMemberInformation/TeamMemberInformation";
import Pagination from "../components/elements/Misc/Pagination/Pagination";
import ListingTeamMembers from "../components/molecules/Listings/ListingTeamMembers/ListingTeamMembers";
import ListingTestimonials from "../components/molecules/Listings/ListingTestimonials/ListingTestimonials";
import ListingInfo from "../components/molecules/Listings/ListingInfo/ListingInfo";
import VideoSpotlight from "../components/molecules/Misc/VideoSpotlight/VideoSpotlight";
import VideoEmbed from "../components/elements/Misc/VideoEmbed/VideoEmbed";
import CalloutList from "../components/molecules/Misc/CalloutList/CalloutList";
import ExpandableSection from "../components/elements/Misc/ExpandableSection/ExpandableSection";
import ExpandableSections from "../components/molecules/Misc/ExpandableSections/ExpandableSections";
import Collage from "../components/molecules/Misc/Collage/Collage";
import HighlightFeatures from "../components/molecules/Highlights/HighlightFeatures/HighlightFeatures";
import HighlightMedia from "../components/molecules/Highlights/HighlightMedia/HighlightMedia";
import HighlightHeadline from "../components/molecules/Highlights/HighlightHeadline/HighlightHeadline";
import HighlightCallout from "../components/molecules/Highlights/HighlightCallout/HighlightCallout";
import CallToAction from "../components/molecules/Misc/CallToAction/CallToAction";
import Callout from "../components/molecules/Misc/Callout/Callout";
import HeroSplit from "../components/molecules/Heros/HeroSplit/HeroSplit";
import HeroComplex from "../components/molecules/Heros/HeroComplex/HeroComplex";
import HeroStandard from "../components/molecules/Heros/HeroStandard/HeroStandard";
import CardCallToAction from "../components/elements/Cards/CardCallToAction/CardCallToAction";
import AnimationConfetti from "../components/atoms/Animation/AnimationConfetti/AnimationConfetti";
import Breadcrumbs from "../components/elements/Misc/Breadcrumbs/Breadcrumbs";
import HeroBasic from "../components/molecules/Heros/HeroBasic/HeroBasic";
import NavigationPopupSubItem from "../components/atoms/Global/NavigationPopupSubItem/NavigationPopupSubItem";
import NavigationPopupItem from "../components/atoms/Global/NavigationPopupItem/NavigationPopupItem";
import NavigationPopup from "../components/molecules/Global/NavigationPopup/NavigationPopup";
import Hamburger from "../components/atoms/Global/Hamburger/Hamburger";
import Header from "../components/molecules/Global/Header/Header";
import Footer from "../components/molecules/Global/Footer/Footer";
import FormMinimal from "../components/elements/Forms/FormMinimal/FormMinimal";
import Form from "../components/elements/Forms/Form/Form";
import ButtonPlay from "../components/atoms/Buttons/ButtonPlay/ButtonPlay";
import ButtonIcon from "../components/atoms/Buttons/ButtonIcon/ButtonIcon";
import TrimWave from "../components/atoms/Trims/TrimWave/TrimWave";
import TrimSlope from "../components/atoms/Trims/TrimSlope/TrimSlope";
import LabelUnderlined from "../components/atoms/Labels/LabelUnderlined/LabelUnderlined";
import MotifFlower from "../components/atoms/Motifs/MotifFlower/MotifFlower";
import ButtonArrow from "../components/atoms/Buttons/ButtonArrow/ButtonArrow";
import CardFeature from "../components/elements/Cards/CardFeature/CardFeature";
import CardTestimonial from "../components/elements/Cards/CardTestimonial/CardTestimonial";
import CardTeamMember from "../components/elements/Cards/CardTeamMember/CardTeamMember";
import CardThree from "../components/elements/Cards/CardThree/CardThree";
import CardTwo from "../components/elements/Cards/CardTwo/CardTwo";
import CardOne from "../components/elements/Cards/CardOne/CardOne";
import ButtonSecondary from "../components/atoms/Buttons/ButtonSecondary/ButtonSecondary";
import ButtonPrimary from "../components/atoms/Buttons/ButtonPrimary/ButtonPrimary";
import HiddenImage from '../components/atoms/Misc/HiddenImage/HiddenImage';

//import Calculator from "../components/molecules/Calculator/Calculator";

$(document).ready(function () {
  var components = [
    // Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".mol-WhatsAppWidget", require: WhatsAppWidget },
{handle: ".mol-CodeEmbed", require: CodeEmbed },
{handle: ".mol-ModalCodeEmbed", require: ModalCodeEmbed },
{handle: ".mol-CalloutWithEmbedModal", require: CalloutWithEmbedModal },
{handle: ".mol-HighlightCallToAction", require: HighlightCallToAction },
{handle: ".mol-HighlightCalloutShapedImage", require: HighlightCalloutShapedImage },
{handle: ".mol-CalloutDualImage", require: CalloutDualImage },
{handle: ".mol-HeroBackgroundImage", require: HeroBackgroundImage },
    {
      handle: ".mol-CalculatorExtended",
      require: CalculatorExtended
    }, {
      handle: ".mol-Calculator",
      require: Calculator
    },
    {
      handle: ".mol-ModalAlert",
      require: ModalAlert
    },
    {
      handle: ".el-ListingJobsDirectorySection",
      require: ListingJobsDirectorySection
    },
    {
      handle: ".mol-ListingJobsDirectory",
      require: ListingJobsDirectory
    },
    {
      handle: ".mol-HighlightForm",
      require: HighlightForm
    },
    {
      handle: ".mol-Banner",
      require: Banner
    },
    {
      handle: ".mol-Intro",
      require: Intro
    },
    {
      handle: ".el-ListingUnitsDirectoryFilters",
      require: ListingUnitsDirectoryFilters
    },
    {
      handle: ".el-ListingUnitsDirectorySection",
      require: ListingUnitsDirectorySection
    },
    {
      handle: ".mol-ListingUnitsDirectory",
      require: ListingUnitsDirectory
    },
    {
      handle: ".atom-NavigationBarSubItem",
      require: NavigationBarSubItem
    },
    {
      handle: ".atom-NavigationBarItem",
      require: NavigationBarItem
    },
    {
      handle: ".mol-NavigationBar",
      require: NavigationBar
    },
    {
      handle: ".mol-EmbedSpotlight",
      require: EmbedSpotlight
    },
    {
      handle: ".mol-UnitInformation",
      require: UnitInformation
    },
    {
      handle: ".atom-ButtonTertiary",
      require: ButtonTertiary
    },
    {
      handle: ".el-PopupUnit",
      require: PopupUnit
    },
    {
      handle: ".mol-FloorPlansMap",
      require: FloorPlansMap
    },
    {
      handle: ".mol-ListingResidenceCategories",
      require: ListingResidenceCategories
    },
    {
      handle: ".mol-ListingUnits",
      require: ListingUnits
    },
    {
      handle: ".el-Carousel",
      require: Carousel
    },
    {
      handle: ".mol-ModalUnit",
      require: ModalUnit
    },
    {
      handle: ".el-CardUnit",
      require: CardUnit
    },
    {
      handle: ".mol-HighlightMap",
      require: HighlightMap
    },
    {
      handle: ".el-Map",
      require: Map
    },
    {
      handle: ".mol-ListingReferences",
      require: ListingReferences
    },
    {
      handle: ".mol-BlogNavigation",
      require: BlogNavigation
    },
    {
      handle: ".mol-PostSpotlight",
      require: PostSpotlight
    },
    {
      handle: ".el-CardFour",
      require: CardFour
    },
    {
      handle: ".mol-ListingPressReleases",
      require: ListingPressReleases
    },
    {
      handle: ".layout-ContainerPressReleases",
      require: ContainerPressReleases
    },
    {
      handle: ".mol-ListingPosts",
      require: ListingPosts
    },
    {
      handle: ".mol-MediaCarousel",
      require: MediaCarousel
    },
    {
      handle: ".el-RecipeSection",
      require: RecipeSection
    },
    {
      handle: ".mol-Recipe",
      require: Recipe
    },
    {
      handle: ".mol-MediaDuo",
      require: MediaDuo
    },
    {
      handle: ".mol-MediaSingle",
      require: MediaSingle
    },
    {
      handle: ".el-ShareSnippet",
      require: ShareSnippet
    },
    {
      handle: ".mol-PostInformation",
      require: PostInformation
    },
    {
      handle: ".mol-HeroPost",
      require: HeroPost
    },
    {
      handle: ".mol-RichText",
      require: RichText
    },
    {
      handle: ".mol-Loader",
      require: Loader
    },
    {
      handle: ".mol-Timeline",
      require: Timeline
    },
    {
      handle: ".mol-ListingFeatures",
      require: ListingFeatures
    },
    {
      handle: ".el-ListingCommunitiesSection",
      require: ListingCommunitiesSection
    },
    {
      handle: ".mol-ListingCommunities",
      require: ListingCommunities
    },
    {
      handle: ".mol-ListingRegions",
      require: ListingRegions
    },
    {
      handle: ".mol-ContactBlock",
      require: ContactBlock
    },
    {
      handle: ".mol-TeamMemberInformation",
      require: TeamMemberInformation
    },
    {
      handle: ".el-Pagination",
      require: Pagination
    },
    {
      handle: ".mol-ListingTeamMembers",
      require: ListingTeamMembers
    },
    {
      handle: ".mol-ListingTestimonials",
      require: ListingTestimonials
    },
    {
      handle: ".mol-ListingInfo",
      require: ListingInfo
    },
    {
      handle: ".mol-VideoSpotlight",
      require: VideoSpotlight
    },
    {
      handle: ".el-VideoEmbed",
      require: VideoEmbed
    },
    {
      handle: ".mol-CalloutList",
      require: CalloutList
    },
    {
      handle: ".el-ExpandableSection",
      require: ExpandableSection
    },
    {
      handle: ".mol-ExpandableSections",
      require: ExpandableSections
    },
    {
      handle: ".mol-Collage",
      require: Collage
    },
    {
      handle: ".mol-HighlightFeatures",
      require: HighlightFeatures
    },
    {
      handle: ".mol-HighlightMedia",
      require: HighlightMedia
    },
    {
      handle: ".mol-HighlightHeadline",
      require: HighlightHeadline
    },
    {
      handle: ".mol-HighlightCallout",
      require: HighlightCallout
    },
    {
      handle: ".mol-CallToAction",
      require: CallToAction
    },
    {
      handle: ".mol-Callout",
      require: Callout
    },
    {
      handle: ".mol-HeroSplit",
      require: HeroSplit
    },
    {
      handle: ".mol-HeroComplex",
      require: HeroComplex
    },
    {
      handle: ".mol-HeroStandard",
      require: HeroStandard
    },
    {
      handle: ".el-CardCallToAction",
      require: CardCallToAction
    },
    {
      handle: ".atom-AnimationConfetti",
      require: AnimationConfetti
    },
    {
      handle: ".el-Breadcrumbs",
      require: Breadcrumbs
    },
    {
      handle: ".mol-HeroBasic",
      require: HeroBasic
    },
    {
      handle: ".atom-NavigationPopupSubItem",
      require: NavigationPopupSubItem
    },
    {
      handle: ".atom-NavigationPopupItem",
      require: NavigationPopupItem
    },
    {
      handle: ".mol-NavigationPopup",
      require: NavigationPopup
    },
    {
      handle: ".atom-Hamburger",
      require: Hamburger
    },
    {
      handle: ".mol-Header",
      require: Header
    },
    {
      handle: ".mol-Footer",
      require: Footer
    },
    {
      handle: ".el-FormMinimal",
      require: FormMinimal
    },
    {
      handle: ".el-Form",
      require: Form
    },
    {
      handle: ".atom-ButtonPlay",
      require: ButtonPlay
    },
    {
      handle: ".atom-ButtonIcon",
      require: ButtonIcon
    },
    {
      handle: ".atom-TrimWave",
      require: TrimWave
    },
    {
      handle: ".atom-TrimSlope",
      require: TrimSlope
    },
    {
      handle: ".atom-LabelUnderlined",
      require: LabelUnderlined
    },
    {
      handle: ".atom-MotifFlower",
      require: MotifFlower
    },
    {
      handle: ".atom-ButtonArrow",
      require: ButtonArrow
    },
    {
      handle: ".el-CardFeature",
      require: CardFeature
    },
    {
      handle: ".el-CardTestimonial",
      require: CardTestimonial
    },
    {
      handle: ".el-CardTeamMember",
      require: CardTeamMember
    },
    {
      handle: ".el-CardThree",
      require: CardThree
    },
    {
      handle: ".el-CardTwo",
      require: CardTwo
    },
    {
      handle: ".el-CardOne",
      require: CardOne
    },
    {
      handle: ".atom-ButtonSecondary",
      require: ButtonSecondary
    },
    {
      handle: ".atom-ButtonPrimary",
      require: ButtonPrimary
    },
    {
      handle: '.atom-HiddenImage',
      require: HiddenImage
    },
    {
      handle: ".comp-Calculator",
      require: Calculator
    }
    // Keep loader last
    // { handle: '.mol-Loader', require: Loader },
  ];

  var sitewide = new Sitewide();
  sitewide.init();

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({
    components: components
  });
  componentsLoader.initScreen();
});
